/* eslint-disable @typescript-eslint/naming-convention -- necessary to remove props from object */
const allRoutesKeys = {
    account: 'account',
    accountLoginRequired: 'account-login-required',
    accountRecovery: 'account-recovery',
    activateAccount: 'activate-account',
    awsOffer: 'aws-offer',
    backupCodeLogin: 'backup-code-login',
    billing: 'billing',
    billingPlans: 'billing-plans',
    billingCheckout: 'billing-checkout',
    partnerOrganizationMigrate: 'partner-organization-migrate',
    configurePermissions: 'configure-permissions',
    developerTools: 'developer-tools',
    directLink: 'direct-link',
    domainManagement: 'domain-management',
    editPermissions: 'edit-permissions',
    error: 'error',
    filespaceCreate: 'filespace-create',
    filespaceDashboard: 'filespace-dashboard',
    filespaceFiles: 'filespace-files',
    filespaceLucidLinkConnect: 'lucidlink-connect',
    filespaceMigration: 'filespace-migration',
    filespaceSettings: 'filespace-settings',
    filespaceUpgrade: 'filespace-upgrade',
    groupDetails: 'group-details',
    groups: 'groups',
    guestLinkMobile: 'guest-link-mobile',
    guests: 'guests',
    guestLogin: 'guest-login',
    guestBrowser: 'guest-browser',
    guestLinks: 'guest-links',
    home: 'home',
    invitation: 'invitation',
    login: 'login',
    memberDetails: 'member-details',
    members: 'members',
    noWorkspaces: 'no-workspaces',
    partnerClient: 'partner-client',
    partnerClients: 'partner-clients',
    partnerCreateContract: 'partner-create-contract',
    partnerUpsell: 'partner-upsell',
    partnerPreviewContract: 'partner-preview-contract',
    partnerDashboard: 'partner-dashboard',
    partnerApiKey: 'partner-api-key',
    partnerDetails: 'partner-details',
    managementPlatform: 'management-platform',
    partnerPrepareUpgrade: 'partner-prepare-upgrade',
    partnerSetupFilespaceUpgrade: 'partner-setup-filespace-upgrade',
    partnerViewFilespaceUpgrade: 'partner-view-filespace-upgrade',
    partnerMigrateContract: 'partner-migrate-contract',
    passwordReset: 'password-reset',
    permissions: 'permissions',
    pinnedFiles: 'pinned-files',
    register: 'register',
    serviceAccounts: 'service-accounts',
    snapshots: 'snapshots',
    ssoAccount: 'sso-account',
    ssoLanding: 'sso-landing',
    ssoLogin: 'sso-login',
    ssoLoginWorkspace: 'sso-login-workspace',
    ssoSettings: 'sso-settings',
    twoFactorAuthentication: 'two-factor-authentication',
    verifyEmail: 'verify-email',
    verifyAccountGuest: 'verify-account-guest',
    workspaceCreate: 'workspace-create',
    workspaceDashboard: 'workspace-dashboard',
    workspaceLock: 'workspace-lock',
    workspacePermissions: 'workspace-permissions',
    workspaceSettings: 'workspace-settings',
    workspaceSuspended: 'workspace-suspended',
    workspaceOnboarding: 'workspace-onboarding',
    zendeskAuth: 'zendesk-auth',
};
// Destructure the keys from the constant holding
// all the route keys that do not need a heading (<h1/> in the header).
// These are usually screens which are not inside
// of the layout with Header and cover the whole screen.
const { accountRecovery, activateAccount, awsOffer, backupCodeLogin, directLink, guestLinkMobile, guestLogin, home, invitation, login, managementPlatform, passwordReset, register, ssoAccount, ssoLoginWorkspace, verifyAccountGuest, verifyEmail, workspaceOnboarding, zendeskAuth, ...reducedKeys } = allRoutesKeys;
export const ROUTE_KEYS = { ...allRoutesKeys };
export const PAGE_TITLE_KEYS = { ...ROUTE_KEYS };
export const HEADING_KEYS = { ...reducedKeys };
/* eslint-enable @typescript-eslint/naming-convention -- necessary to remove props from object */
